export const popupMixin = {
    data(){
        return {
            popupInstance: null
        }
    },
    methods: {
        open(){
            frontUI.refreshUI();

            this.popupInstance = $(this.$el).data('ui');
            this.popupInstance.open();
            this.popupInstance.beforeCloseCallback(this.close);
        },
        close(){
            this.popupInstance.closeCommonMotion({
                cancelMotion: false,
                callback: () => {
                    this.$emit('onpopupclose', this.$options._componentTag)
                }});
        }
    },
    beforeDestroy(){
        this.popupInstance.close(true);
    }
}